import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

class Breadcrumb extends React.PureComponent {
  renderMobile() {
    const { props } = this;
    const { firstPathSelectable } = props;
    const length = props.path.length;

    const item =
      props.path.length <= 1
        ? { name: props.homeText, pathName: '/' }
        : props.path[firstPathSelectable ? length - 1 : length - 2];

    return (
      <S.Breadcrumbs mobile data-test="Breadcrumbs">
        <S.Crumb to={item.pathName} data-test-path={item.pathName}>
          <S.ArrowLeft mobile />
          <S.Ellipsis>{item.name}</S.Ellipsis>
        </S.Crumb>
      </S.Breadcrumbs>
    );
  }

  renderDesktop() {
    const { props } = this;
    const { firstPathSelectable } = props;

    return (
      <S.Breadcrumbs desktop data-test="Breadcrumbs">
        <S.Crumb to="/">{props.homeText}</S.Crumb>

        {props.path.map((p, index) => (
          <React.Fragment key={p.name}>
            <S.ArrowRight />

            {(index !== props.path.length - 1 || firstPathSelectable) && (
              <S.Crumb to={p.pathName} data-test-path={p.pathName}>
                <S.Ellipsis title={p.name}>{p.name}</S.Ellipsis>
              </S.Crumb>
            )}

            {index === props.path.length - 1 && !firstPathSelectable && (
              <S.Current data-test-path={p.pathName}>
                <S.Ellipsis title={p.name}>{p.name}</S.Ellipsis>
              </S.Current>
            )}
          </React.Fragment>
        ))}
      </S.Breadcrumbs>
    );
  }

  render() {
    return (
      <>
        {this.renderMobile()}
        {this.renderDesktop()}
      </>
    );
  }
}

Breadcrumb.propTypes = {
  homeText: PropTypes.string.isRequired,
  path: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired,
      pathName: PropTypes.string.isRequired,
    })
  ),
  firstPathSelectable: PropTypes.bool,
};

Breadcrumb.defaultProps = {
  path: [],
  firstPathSelectable: false,
};

Breadcrumb.contextType = AppContext;

export default Breadcrumb;
